import React from 'react';

import { trans } from '@spotahome/soyuz/client';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

const AboutDifferent = () => (
  <div className="wrapper">
    <div className="one-col one-col--center">
      <SectionHeading text={trans('about-us.different.title')} />
      <p className="mb-xl">{trans('about-us.different.paragraph-1')}</p>
      <p className="mb-xl">{trans('about-us.different.paragraph-2')}</p>
      <p>{trans('about-us.different.paragraph-3')}</p>
    </div>
  </div>
);

export default AboutDifferent;
